'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Autobind = undefined;

var _DecorateInstance = require('./DecorateInstance');

var Autobind = exports.Autobind = (0, _DecorateInstance.DecorateInstance)(function (fn) {
    return fn.bind(this);
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9BdXRvYmluZC5qcyJdLCJuYW1lcyI6WyJBdXRvYmluZCIsImZuIiwiYmluZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVPLElBQU1BLDhCQUFXLHdDQUFpQixVQUFTQyxFQUFULEVBQWE7QUFDbEQsV0FBT0EsR0FBR0MsSUFBSCxDQUFRLElBQVIsQ0FBUDtBQUNILENBRnVCLENBQWpCIiwiZmlsZSI6IkF1dG9iaW5kLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtEZWNvcmF0ZUluc3RhbmNlfSBmcm9tICcuL0RlY29yYXRlSW5zdGFuY2UnO1xuXG5leHBvcnQgY29uc3QgQXV0b2JpbmQgPSBEZWNvcmF0ZUluc3RhbmNlKGZ1bmN0aW9uKGZuKSB7XG4gICAgcmV0dXJuIGZuLmJpbmQodGhpcyk7XG59KTtcbiJdfQ==